module.exports = __webpack_public_path__ + "static/img/7.29839a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7.png
// module id = 203
// module chunks = 1